import { render, staticRenderFns } from "./DeviceStatusUpdateModal.vue?vue&type=template&id=545db47b&scoped=true&"
import script from "./DeviceStatusUpdateModal.vue?vue&type=script&lang=js&"
export * from "./DeviceStatusUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545db47b",
  null
  
)

export default component.exports